import _typeof from "@babel/runtime/helpers/typeof";
export function getExtensionRenderer(extensionHandler) {
  if (_typeof(extensionHandler) === 'object') {
    return extensionHandler.render;
  } else {
    return extensionHandler;
  }
}